import React from 'react';

import { CompetitionClosed_ } from './style';

const CompetitionClosed = () => {
  return (
    <CompetitionClosed_>
      <h2>Sorry the competition has now closed</h2>
    </CompetitionClosed_>
  );
};

export default CompetitionClosed;
